var SecurityCommandScript = require('./security-command-script');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var script = Codec.readString(input);
        return new SecurityCommandScript(script);
    }, 
    write : function(output, value) {
        Codec.writeString(output, value.script);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/authentication/security-command-script-serialiser.js
// module id = 1029
// module chunks = 1